import {Component, OnInit} from '@angular/core';
import {MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';

@Component({
    selector: 'app-limit-reached',
    templateUrl: './limit-reached.component.html',
    styleUrls: ['./limit-reached.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent]
})
export class LimitReachedComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LimitReachedComponent>,
  ) { }

  ngOnInit(): void {
  }

}
